import styled from "styled-components";

import { mixins, colorsPalettes } from "@similarweb/styles";
import { SimpleDropdownItem } from "@similarweb/ui-components";

export const StyledSimpleDropdownItem = styled(SimpleDropdownItem)``;

export const DropdownContainer = styled.div`
    position: relative;
    width: 250px;

    ${StyledSimpleDropdownItem} {
        ${mixins.setFont({ $size: 14, $color: colorsPalettes.carbon[500], $weight: 400 })};
        line-height: 16px;
        display: flex;
        align-items: center;
    }
`;
